import React, { useState, useEffect } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { connect } from 'react-redux';
import { RayTable, CustomFieldListHeader } from '../../components/common';
import { CustomFieldAction } from '../../actions/CustomFieldAction';
import CustomFieldModal from '../../components/common/CustomFieldModal';
import { Translate as t } from '../../config/Translate';
import { SettingsReturnButton } from '../user/AdminSettingShortcuts';

const AdminCustomField = ({ items, AddUpdate, isLoading }) => {

	const [showModal, setShowModal] = useState(false);
	const [item, setItem] = useState({});

	const options = {
		search: true,
		showClear: true,
		keyCol: '_id',
		linkkey: 'code',
		searchCols: ['group', 'code', 'title'],
		filterColumns: [
			{ col: 'type', val: 'ALL' },
		],
		defaultSort: 'code',
	};

	const selected = (e) => {
		console.log(e);
		setItem(e);
		setShowModal(true);
	}

	const addNew = () => {
		setItem({});
		setShowModal(true);
	}

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">
					{t('common.label.customFieldList')}
				</h2>
				<div className="ray-right">
						<SettingsReturnButton />
					<button className="btn btn-primary btn-sm mt-0" onClick={() => addNew()}>
						<ion-icon name="add-outline"></ion-icon>
						{t('common.button.addCustomField')}
					</button>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				<div className="section mt-1 mb-1">
					<div className="wide-block pt-2 pb-2">
						<RayTable
							stateKey={LIST_STATE_KEYS.ADMIN_CUSTOM_FIELD}
							data={items}
							rowSelectCallback={(e) => selected(e)}
							columns={CustomFieldListHeader}
							isLoading={isLoading}
							options={options} />
					</div>
				</div>
			</div>
			<CustomFieldModal
				showModal={showModal}
				data={item}
				callbackClose={() => setShowModal(false)} />
		</>
	);
};

const mapState = (state) => {
	const items = state.CustomFieldReducer.items;
	const isLoading = state.CustomFieldReducer.isLoading;
	return { items, isLoading };
};

const mapDispatch = (dispatch) => ({
	//GetAll: (filter) => dispatch(CustomFieldAction.GetAll(filter)),
	AddUpdate: (item) => dispatch(CustomFieldAction.AddUpdate(item)),
});

export default connect(mapState, mapDispatch)(AdminCustomField);